import Vue from 'vue'
import Router from 'vue-router'
import Billpay from './pages/Billpay.vue'
import Transaction from './pages/Transaction.vue'
import Report from './pages/Report.vue'
import Complaint from './pages/Complaint.vue'
import Request from './pages/Request.vue'
import Setting from './pages/Setting.vue'
import Support from './pages/Support.vue'
import Account from './pages/Login.vue'
import Offer from './pages/Offer.vue'
import Commission from './pages/Commission.vue'
import Downline from './pages/Downline.vue'
import Recharge from './pages/Recharge.vue'
import LastTransaction from './pages/LastTransaction.vue'
import Outstanding from './pages/Outstanding.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'billpay',
      component:Billpay
    },
    {
      path: '/downline',
      name: 'downline',
      component:Downline
    },
    {
      path: '/recharge',
      name: 'recharge',
      component:Recharge
    },
    {
      path: '/transaction',
      name: 'transaction',
      component:Transaction
    },
    {
      path: '/lasttransaction',
      name: 'lasttransaction',
      component:LastTransaction
    },
    {
      path: '/report',
      name: 'report',
      component:Report
    },
    {
      path: '/complaint',
      name: 'complaint',
      component:Complaint
    },
    {
      path: '/request',
      name: 'request',
      component:Request
    },
    {
      path: '/offer',
      name: 'offer',
      component:Offer
    },
    {
      path: '/commission',
      name: 'commission',
      component:Commission
    },
    {
      path: '/setting',
      name: 'setting',
      component:Setting
    },
    {
      path: '/support',
      name: 'support',
      component:Support
    },
    {
      path: '/account',
      name: 'account',
      component:Account
    },
    {
      path: '/outstanding',
      name: 'outstanding',
      component:Outstanding
    },
  ]
})
